import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Schedule } from './pages/Schedule';
import { Portfolio } from './pages/Portfolio';
import { LessonPolicies } from './pages/LessonPolicies';
import { Pay } from './pages/Pay';
import { EditBar } from './edit/EditBar';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/lesson-policies" element={<LessonPolicies />} />
        <Route path="/pay" element={<Pay />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <EditBar />
    </>
  );
}

export default App;
